import React, { Component } from 'react';
// eslint-disable-next-line
import styled, { css } from "styled-components";
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import { Link } from '@trp-rps-rps-shared-web/rps-shared-web-components';
import { getDomain } from '../../utils/api';

const StyledOverlay = styled.div`
  position: absolute;
  z-index: 100;
  width: 100%;
  height: calc(100vh * 2);
  margin-top: -150px;
  background-color: #000000;
  opacity: 0.8;
  @media (max-width: 768px) {
    background-color: ${tokens.ColorWhite000};
    opacity: 1;
    top: 0;
  }
`;

const StyledMessage = styled.div`
  position: absolute;
  width: 640px;
  z-index: 101;
  border-radius: 8px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: ${tokens.ColorWhite000};
  padding: 64px;
  text-align: center;
  @media (max-width: 768px) {
    border-radius: 0;
    padding: 32px;
    max-width: calc(100vw - 32px);
    width: calc(100vw - 32px);
  }
`;

const Icon = styled.img`
  width: 64px;
  height: 64px;
  margin-bottom: 32px;
`;

const StyledMessageText = styled.div`
  font-family: Nimbus Sans Light;
  font-size: 40px;
  line-height: 46px;
  letter-spacing: -0.75px;
  text-align: center;
  margin-bottom: 32px;
  @media (max-width: 768px) {
    font-family: Nimbus Sans Light;
    font-size: 24px;
    line-height: 32px;
  }
`;

const Content = styled.div`
  font-family: Nimbus Sans Regular;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.1px;
  text-align: center;
  color: ${tokens.ColorGrey700};
`;
class RIXIneligible extends Component<any, any> {
  componentDidMount() {
    const w = window as any;
    w.noScroll();
  }
  render(): JSX.Element {
    return (
      <>
        <StyledOverlay tabIndex={0} />
        <StyledMessage>
          <Icon src={`data:image/svg+xml;base64,${tokens.AssetIconCaution}`} />
          <StyledMessageText>We ran into an issue.</StyledMessageText>
          <Content>
            {' '}
            There seems to be an issue with your account information.
            <Link
              linkLabel={'Contact a representative'}
              href={getDomain() + '/rps/rws/account/participant/contactus.otc'}
              customStyles={'display: inline; text-decoration: underline; margin-left: 4px;'}
            />{' '}
            to make an update.
          </Content>
        </StyledMessage>
      </>
    );
  }
}

export default RIXIneligible;
